// extracted by mini-css-extract-plugin
export default {"workOrderOtherEditableCell":"WorkOrderOtherEditableCell_workOrderOtherEditableCell__4VXne"};